import ReactGA from 'react-ga4';
import { trackMoengageEvent } from '../moengage/moengage';

export const trackEventGA4 = (args) => {
  const { category, event, is_non_interaction, params, moengage } = args;
  setTimeout(() => {
    ReactGA.event(event, { category, is_non_interaction, ...params });
  }, 10);
  if (moengage) {
    try {
      trackMoengageEvent(event, {
        category: moengage.category ?? category,
        is_non_interaction,
        ...params,
      });
    } catch (e) {
      // MoEngage must never affect GA4
    }
  }
};
